module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3tkoJ"))).then(() => module.bundle.root('gtEzC'));